import { AddBoxOutlined } from '@mui/icons-material';
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import Breadcrumb from './Breadcrumb';
import { Accordion, Card, Nav, Tab } from "react-bootstrap";
import EraseCheck from '../../MySections/PopUps/EraseCheck';
import InputSet from '../../MySections/PopUps/InputSet';
import utilsRestMenus from '../../../MyConns/_Utils/utilsRestMenus';
import SucessToast from '../../MySections/Toasts/SucessToast';
import AccordDiv from '../RestsP/Rests/parts/menuAcoordParts/AccordDiv';
import AccordProd from '../RestsP/Rests/parts/menuAcoordParts/AccordProd';
import DivSmalltext from '../RestsP/Rests/parts/menuAcoordParts/DivSmalltext';
import MySpinner_Wait from '../../MySections/DTechComps/MySpinner_Wait';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import RichTextComp from '../../MySections/TextEditor/RichText';
import MyTextArea from '../../MySections/TextEditor/MyTextArea';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TabPageDetails from '../compsForAllPages/TabPageDetails';

function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}

const TabMenu = (props) => {
    const [thePopUp, setThePopUp] = useState("");
    const [buisMenu, setBuisMenu] = useState([]);
    const [menuStarters, setMenuStarters] = useState({});
    const [mnubuis, setMnubuis] = useState({});
    const [diag, setDiag] = useState("");
    const [loading, setLoading] = useState(true);
    const [activeDivisionKeys, setActiveDivisionKeys] = useState([]);
    const [mnuItemMainImg, setMnuItemMainImg] = useState("");
    const [currSingle, setCurrSingle] = useState([]);


    const [dragging, setDragging] = useState(false);

    useEffect(() => {
        const getTheMenu = async () => {
            try {
                let mnubuis = await utilsRestMenus.getRestMenu();
                setMnubuis(mnubuis);
                setBuisMenu(mnubuis.buisMenu || []);
                setMenuStarters(mnubuis.menuStarters || {});
                setMnuItemMainImg(mnubuis.mnuItemMainImg || "");

            } catch (error) {
                console.error("Error fetching menu:", error);
            } finally {
                setLoading(false);
            }
        };
        getTheMenu();
    }, []);

    // handleDragEnd: שינוי סדר מוצרים באותה מחלקה
    // handleDragEnd: שינוי סדר מוצרים בעקבות גרירה
    const handleDragEnd = (result) => {
        // אם אין יעד, מבטלים
        if (!result.destination) return;

        const { source, destination } = result;
        const sourceDivisionIndex = parseInt(source.droppableId.replace('droppable-', ''), 10);
        const destinationDivisionIndex = parseInt(destination.droppableId.replace('droppable-', ''), 10);

        // גרירה באותה מחלקה
        if (source.droppableId === destination.droppableId) {
            const currentProducts = buisMenu[sourceDivisionIndex].Products || [];
            const reordered = reorder(currentProducts, source.index, destination.index);

            const newMenu = [...buisMenu];
            newMenu[sourceDivisionIndex] = {
                ...newMenu[sourceDivisionIndex],
                Products: reordered
            };
            setBuisMenu(newMenu);
        } else {
            // גרירה בין מחלקות
            const newMenu = [...buisMenu];
            // שולפים את המוצר ממחלקת המקור
            const [movedProduct] = newMenu[sourceDivisionIndex].Products.splice(source.index, 1);
            // מוסיפים אותו למחלקת היעד (במיקום הנכון)
            newMenu[destinationDivisionIndex].Products.splice(destination.index, 0, movedProduct);
            setBuisMenu(newMenu);
        }

        // אם רוצים לסגור בחזרה את כל המחלקות עם תום הגרירה
        // או כל מבנה אחר שנרצה
        // setActiveDivisionKeys([`division-${destinationDivisionIndex}`]);

    };

    // -- דוגמה לפתיחה של כל המחלקות כאשר מתחילה גרירה --
    const handleDragStart = () => {
        // יוצרים מערך של כל המחלקות
        // const allKeys = buisMenu.map((_, i) => "division-" + i);
        // setActiveDivisionKeys(allKeys);
    };
    const closeOpenDrop = (item) => {
        // // יוצרים מערך של כל המחלקות
        // const allKeys = buisMenu.map((_, i) => "division-" + i);
        let temkeys = [...activeDivisionKeys];

        let found = activeDivisionKeys.findIndex(it => it == item);
        if (found !== -1) {
            temkeys.splice(found, 1)
            setActiveDivisionKeys(temkeys)

        }
        else {

            temkeys.push(item)
            setActiveDivisionKeys(temkeys)
        }
    };



    // שמירה בבסיס הנתונים
    const updateTheMenu = async () => {
        let upObject = {mnubuis, menuStarters, buisMenu, mnuItemMainImg };
        try {
            setLoading(true);
            let mnubuis = await utilsRestMenus.updateRestMnu(upObject);

            setBuisMenu(mnubuis.buisMenu);
            setMenuStarters(mnubuis.menuStarters);
            setMnuItemMainImg(mnubuis.mnuItemMainImg);
            SucessToast({ position: "toast-bottom-right", text: "עודכן בהצלחה!" });
        } catch (err) {
            console.error("Error updating menu:", err);
        } finally {
            setLoading(false);
        }
    };

    // הזזה של מחלקות למעלה/למטה (לא קשור ל-dnd)
    const array_move = (arr, old_index, new_index) => {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };
    const setUp = (index) => {
        let temp = array_move([...buisMenu], index, index - 1);
        setBuisMenu(temp);
    };
    const setDown = (index) => {
        let temp = array_move([...buisMenu], index, index + 1);
        setBuisMenu(temp);
    };

    const setDivDescription = (index, newVal) => {
        let temp = [...buisMenu];
        temp[index].DivDescript = newVal;
        setBuisMenu(temp);
    };
    const removeDivi = (diviIndex) => {
        setThePopUp(
            <EraseCheck
                title={'האם בטוח למחוק את המחלקה?'}
                sucecssFunc={() => removeDivision(diviIndex)}
            />
        );
    };
    const removeDivision = (diviIndex) => {
        let temp = [...buisMenu];
        temp.splice(diviIndex, 1);
        setBuisMenu(temp);
    };

    const createNewSection = () => {
        setThePopUp(
            <InputSet
                Title={"יצירת מחלקה"}
                ContentText={"שם המחלקה"}
                inLabel={""}
                okClick={(textBack) => createSectionOK(textBack)}
                cancelClick={() => setThePopUp("")}
                errorMsg={"על מנת ליצור מחלקה חדשה, חובה לתת לה שם."}
            />
        );
    };
    const createSectionOK = (textBack) => {
        let newSection = { _id: Date.now(), DivName: textBack, Products: [] };
        let temp = [...buisMenu];
        temp.push(newSection);
        setBuisMenu(temp);
        setThePopUp("");
    };

    const createNewProduct = (divindex) => {
        setThePopUp(
            <InputSet
                Title={"הוספת מוצר"}
                ContentText={"שם המוצר"}
                inLabel={""}
                okClick={(textBack) => createProductOK(textBack, divindex)}
                cancelClick={() => setThePopUp("")}
                errorMsg={"על מנת ליצור מוצר חדש, חובה לתת לו שם."}
            />
        );
    };
    const createProductOK = (textBack, divindex) => {
        // יוצרים מוצר עם מזהה יחודי (_id) כדי לזהות אותו אחרי גרירה
        let newProduct = {
            _id: Date.now(), // או uuid()
            newProd: true,
            prodName: textBack,
            prodImageUrl: "",
            prodProducts: "",
            prodPrice: 0,
            prodRemarks: "",
            prodProperties: "",
            okToDeliver: true,
            inStock: true,
            prodOptions: [],
        };
        let temp = [...buisMenu];
        temp[divindex].Products.push(newProduct);
        setBuisMenu(temp);
        setThePopUp("");
    };

    const changeDivName = (divIndex, newValue) => {
        let temp = [...buisMenu];
        temp[divIndex].DivName = newValue;
        setBuisMenu(temp);
    };

    // עדכון תמונת הפתיח/טקסט הפתיח (לא קשור לגרירה)
    const setMenuSterterImg = (urlToImg) => {
        let temp = { ...menuStarters };
        temp.mainImage = urlToImg;
        setMenuStarters(temp);
    };
    const setMenuSterterText = (theText) => {
        let temp = { ...menuStarters };
        temp.mainContent = theText;
        setMenuStarters(temp);
    };

    const updatePDetails = (key, val) => {
        let tempMnubuis = { ...mnubuis };
        tempMnubuis[key] = val;
        setMnubuis({ ...tempMnubuis })
    }

    return (
        <div className="ms-content-wrapper SetBlock">
            {loading ? (
                <MySpinner_Wait />
            ) : (
                <div className="col-md-12">
                    <Breadcrumb />
                    <div className="ms-panel">
                        <div className="ms-panel-header">
                            <div>
                                <h3>עמוד תפריט</h3>
                            </div>
                        </div>



                        <Tab.Container defaultActiveKey="tab2">
                            <Tab.Content>
                                <Nav variant="tabs" className="nav nav-tabs d-flex nav-justified mb-2">
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab2">תוכן</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab1">פרטי העמוד</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Pane eventKey="tab2">

                                    <div className="ms-panel-body clearfix">
                                        <div className="ms-panel-header">
                                            <h6>פתיח</h6>
                                        </div>
                                        <Accordion defaultActiveKey="0" className="has-gap ms-accordion-chevron menuSectionsAcord">
                                            <Card>
                                                <Accordion.Collapse className="collapseparent" eventKey={"topOne"}>
                                                    <Card.Body>
                                                        <div className="col-md-2 mb-12 onRight">
                                                            <label>תמונה ראשית</label>
                                                            <SelectImgComp
                                                                firstImgToDisp={menuStarters.mainImage || ""}
                                                                theFunction={(fUrl) => setMenuSterterImg(fUrl)}
                                                            />
                                                        </div>
                                                        <div className="col-md-9 mb-12 onRight">
                                                            <label>טקסט ראשי קצר</label>
                                                            <div className="input-group">
                                                                <MyTextArea
                                                                    lbl="טקסט"
                                                                    lblCss="bold"
                                                                    firstText={menuStarters.mainContent || ""}
                                                                    cssStyle="regularInput"
                                                                    saveEditorTxt={(content) => setMenuSterterText(content)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                                <Accordion.Toggle as={Card.Header} eventKey={"topOne"}>
                                                    <span>{"פתיח עמוד"}</span>
                                                    <span className="noBold"></span>
                                                </Accordion.Toggle>
                                            </Card>
                                        </Accordion>
                                    </div>

                                    <div className="ms-panel ms-panel-fh">
                                        <div className="ms-panel-header">
                                            <h6>תפריט</h6>
                                        </div>

                                        <div className="ms-panel-body clearfix">
                                            <div className="col-md-12 mb-2 onRight">
                                                <div className="col-md-5 mb-2 onRight">
                                                    <Button
                                                        className="addDivBtn"
                                                        variant="contained"
                                                        onClick={() => createNewSection()}
                                                        startIcon={<AddBoxOutlined style={{ color: 'white' }} />}
                                                    >
                                                        מחלקה
                                                    </Button>
                                                </div>
                                                <div className={"col-md-5 mb-2 onLeft"}>
                                                    <label htmlFor={"validationCustom10"} className={"input-group onRight"}>תמונה ראשונית (472X295)</label>
                                                    <SelectImgComp imgCss={"medImgDisp pointing"} firstImgToDisp={mnuItemMainImg ? mnuItemMainImg : ""}
                                                        theFunction={(fUrl) => { setMnuItemMainImg(fUrl); buisMenu["mnuItemMainImg"] = fUrl }} />
                                                </div>

                                            </div>

                                            {/** DragDropContext עוטף את כל המחלקות */}
                                            <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                                                <Accordion className="has-gap ms-accordion-chevron menuSectionsAcord">
                                                    {buisMenu.map((item, index) => {
                                                        // const accordionKey = ;
                                                        // console.log(accordionKey);

                                                        return (
                                                            <Card key={item._id || index}>
                                                                <Accordion.Collapse className="collapseparent" in={activeDivisionKeys.findIndex(it => it === ("division-" + index)) != -1}>
                                                                    <Card.Body>
                                                                        <Droppable droppableId={`droppable-${index}`}>
                                                                            {(provided) => (
                                                                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                                                                    <Accordion
                                                                                        defaultActiveKey="0"
                                                                                        className="has-gap ms-accordion-chevron menuSectionsAcord"
                                                                                    >
                                                                                        <AccordDiv
                                                                                            index={index}
                                                                                            DivName={item.DivName}
                                                                                            changeDivName={changeDivName}
                                                                                        />
                                                                                        <DivSmalltext
                                                                                            prodTxtVal={item.DivDescript || ""}
                                                                                            clss="DivSmalltext prodFirst"
                                                                                            headI="טקסט קצר למחלקה"
                                                                                            setDivDescription={(val) => setDivDescription(index, val)}
                                                                                        />
                                                                                        <Button
                                                                                            variant="contained"
                                                                                            onClick={() => createNewProduct(index)}
                                                                                            className="addDivBtn"
                                                                                            startIcon={<AddBoxOutlined style={{ color: 'white' }} />}
                                                                                        >
                                                                                            הוסף מוצר
                                                                                        </Button>

                                                                                        {item.Products?.map((produc, proIndex) => {
                                                                                            const draggableId = String(produc._id || "noID-" + proIndex);
                                                                                            return (
                                                                                                <Draggable
                                                                                                    key={draggableId}
                                                                                                    draggableId={draggableId}
                                                                                                    index={proIndex}
                                                                                                >
                                                                                                    {(provided) => (
                                                                                                        <div
                                                                                                            ref={provided.innerRef}
                                                                                                            {...provided.draggableProps}
                                                                                                            {...provided.dragHandleProps}
                                                                                                            style={{
                                                                                                                marginBottom: 8,
                                                                                                                ...provided.draggableProps.style,
                                                                                                            }}
                                                                                                        >
                                                                                                            <AccordProd
                                                                                                                divisionIndex={index}
                                                                                                                produc={produc}
                                                                                                                proIndex={proIndex}
                                                                                                                productsLength={item.Products.length}
                                                                                                                theMenu={buisMenu}
                                                                                                                UpdateTheBuis={(temp) => setBuisMenu(temp)}
                                                                                                            />
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Draggable>
                                                                                            );
                                                                                        })}
                                                                                        {provided.placeholder}
                                                                                    </Accordion>
                                                                                </div>
                                                                            )}
                                                                        </Droppable>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                                <div className="card-header" onClick={() => closeOpenDrop("division-" + index)}>
                                                                    <span>{item.DivName}</span>
                                                                    <span className="noBold"></span>
                                                                </div>

                                                                <div className="acoordBtns">
                                                                    <div
                                                                        className="acoordIcon acord1 pointing"
                                                                        onClick={() => removeDivi(index)}
                                                                    >
                                                                        <i className="far fa-trash-alt theSecIconsColor onLeft" />
                                                                    </div>
                                                                    {index !== 0 && buisMenu.length > 1 && (
                                                                        <div
                                                                            className="acoordIcon acord2 pointing"
                                                                            onClick={() => setUp(index)}
                                                                            title="הקפץ למעלה"
                                                                        >
                                                                            <i className="far fa-caret-square-up theSecIconsColor onLeft" />
                                                                        </div>
                                                                    )}
                                                                    {index < buisMenu.length - 1 && (
                                                                        <div
                                                                            className="acoordIcon acord3 pointing"
                                                                            onClick={() => setDown(index)}
                                                                            title="הקפץ למטה"
                                                                        >
                                                                            <i className="far fa-caret-square-down theSecIconsColor onLeft" />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Card>
                                                        );
                                                    })}
                                                </Accordion>
                                            </DragDropContext>

                                            {diag}
                                        </div>
                                    </div>
                                </Tab.Pane>
                                {/* פרטי העמוד */}
                                <Tab.Pane eventKey="tab1">
                                    <div className="form-row tabsInputs ">
                                        <TabPageDetails pgToSet="pgPageDetails"
                                            thePage={mnubuis} thePageUpdate={(key, val) => updatePDetails(key, val)} />
                                    </div>
                                </Tab.Pane>

                            </Tab.Content>
                        </Tab.Container>
                    </div>

                    <div className="ms-panel-header approveLine">
                        <button
                            type="button"
                            className="onLeft btn btn-primary"
                            onClick={() => updateTheMenu()}
                        >
                            שמור
                        </button>
                    </div>
                    {thePopUp}
                </div>
            )
            }
        </div >
    );
};

export default TabMenu;
